import { LoadableFactory } from '®shared/data';

import {
  ItemResolverStoreActionTypes,
  ItemResolverStoreActions,
} from './item-resolver-store.actions';
import { ItemResolverStoreState } from './item-resolver-store.state';

export function itemResolverStoreReducer(
  state: ItemResolverStoreState,
  action: ItemResolverStoreActions,
): ItemResolverStoreState {
  switch (action.type) {
    case ItemResolverStoreActionTypes.DRAFT_ITEM_REQUESTED: {
      return {
        ...state,
        draftItemsById: state.draftItemsById.set(
          action.payload.itemId,
          LoadableFactory.loading(),
        ),
      };
    }
    case ItemResolverStoreActionTypes.DRAFT_ITEM_LOADED: {
      const { itemId, item } = action.payload;
      return {
        ...state,
        draftItemsById: state.draftItemsById.set(
          itemId,
          LoadableFactory.loaded(item),
        ),
      };
    }
    case ItemResolverStoreActionTypes.DRAFT_ITEM_LOADING_FAILED: {
      const { itemId, error } = action.payload;
      return {
        ...state,
        draftItemsById: state.draftItemsById.set(
          itemId,
          LoadableFactory.errored(error),
        ),
      };
    }
    case ItemResolverStoreActionTypes.PUBLISHED_ITEM_REQUESTED: {
      return {
        ...state,
        publishedItemsById: state.publishedItemsById.set(
          action.payload.itemId,
          LoadableFactory.loading(),
        ),
      };
    }
    case ItemResolverStoreActionTypes.PUBLISHED_ITEM_LOADED: {
      const { itemId, item } = action.payload;
      return {
        ...state,
        publishedItemsById: state.publishedItemsById.set(
          itemId,
          LoadableFactory.loaded(item),
        ),
      };
    }
    case ItemResolverStoreActionTypes.PUBLISHED_ITEM_LOADING_FAILED: {
      const { itemId, error } = action.payload;
      return {
        ...state,
        publishedItemsById: state.publishedItemsById.set(
          itemId,
          LoadableFactory.errored(error),
        ),
      };
    }
  }

  return state;
}
